var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Container } from "@/components/common/Container";
import { PageTitle } from "@/components/common/PageTitle";
import { ServiceInfo, ServiceInfoItem } from "@/components/common/ServiceInfo";
import { Button } from "@/components/ui/Button";
import { Checkbox } from "@/components/ui/Checkbox";
import { Form, FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage, } from "@/components/ui/Form";
import { Input } from "@/components/ui/Input";
import { InputMask } from "@/components/ui/InputMask";
import { Label } from "@/components/ui/Label";
import { LoadingSpinner } from "@/components/ui/LoadingSpinner";
import { RadioGroup, RadioGroupItem } from "@/components/ui/RadioGroup";
import { useStepperControl } from "@/hooks/useStepperControl";
import { cn } from "@/lib/utils";
import { ResponseModel } from "@/models/ResponseModel";
import GatewayService from "@/services/api/GatewayService";
import { zodResolver } from "@hookform/resolvers/zod";
import { Share2Icon } from "@radix-ui/react-icons";
import { isAxiosError } from "axios";
import { AlertTriangle } from "lucide-react";
import { useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { z } from "zod";
var cursosEspeciaisList = [
    {
        id: "transporteProdutosPerigosos",
        label: "Transporte de Produtos Perigosos",
    },
    { id: "transporteEscolar", label: "Transporte Escolar" },
    {
        id: "transporteColetivoPassageiros",
        label: "Transporte Coletivo de Passageiros",
    },
    {
        id: "transporteVeiculosEmergencia",
        label: "Transporte de Veículos de Emergência",
    },
    {
        id: "transporteCargaIndivisivel",
        label: "Transporte de Carga Indivisível",
    },
    { id: "mototaxista", label: "Mototaxista" },
    { id: "motofretista", label: "Motofretista" },
];
function transformCourseArrayInObj(selected) {
    return cursosEspeciaisList.reduce(function (acc, _a) {
        var id = _a.id;
        acc[id] = selected.includes(id);
        return acc;
    }, {});
}
export function DadosProcesso() {
    var _this = this;
    var service = new GatewayService();
    var _a = useState(false), isLoading = _a[0], setIsLoading = _a[1];
    var _b = useState(""), error = _b[0], setError = _b[1];
    var formSchema = z
        .object({
        telefoneCelular: z
            .string()
            .length(11, "O número de telefone deve conter 11 caracteres"),
        email: z.string().email("O campo deve conter um e-mail válido"),
        exerceAtividade: z.boolean().default(false),
        temCursosEspeciais: z.boolean().default(false),
        cursosEspeciais: z.array(z.string()).optional(),
    })
        .refine(function (data) {
        if (!data.temCursosEspeciais)
            return true;
        return data.cursosEspeciais && data.cursosEspeciais.length > 0;
    }, {
        message: "Selecione pelo menos uma atividade especial.",
        path: ["cursosEspeciais"],
    });
    var _c = useStepperControl(), handleNextStep = _c.handleNextStep, setServiceReturn = _c.setServiceReturn, requestDto = _c.requestDto, setRequestDto = _c.setRequestDto;
    var DEFAULT_VALUES = useMemo(function () {
        return ({
            email: "",
            telefoneCelular: "",
            exerceAtividade: false,
            temCursosEspeciais: false,
            cursosEspeciais: [],
        });
    }, []);
    var form = useForm({
        resolver: zodResolver(formSchema),
        defaultValues: DEFAULT_VALUES,
    });
    var goNext = function () {
        handleNextStep();
    };
    var onSubmit = function (values) { return __awaiter(_this, void 0, void 0, function () {
        var cursosEspeciaisObj, dadosProcesso, data, ret, e_1;
        var _a, _b, _c, _d, _e, _f, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    if (!values) {
                        throw Error("Erro ao buscar dados do processo");
                    }
                    setIsLoading(true);
                    setError("");
                    _h.label = 1;
                case 1:
                    _h.trys.push([1, 3, 4, 5]);
                    cursosEspeciaisObj = transformCourseArrayInObj((_a = values.cursosEspeciais) !== null && _a !== void 0 ? _a : []);
                    dadosProcesso = {
                        telefoneCelular: values.telefoneCelular.replace(/[^\d]/g, ""),
                        email: values.email,
                        exerceAtividade: values.exerceAtividade,
                        cursosEspeciais: cursosEspeciaisObj,
                    };
                    data = __assign(__assign({}, requestDto), { dadosProcesso: dadosProcesso });
                    data.espelhoCnh = "";
                    return [4 /*yield*/, service.solicitarRenovacao(data)];
                case 2:
                    ret = _h.sent();
                    if (ResponseModel.isOk(ret)) {
                        setServiceReturn(ret.data);
                        setRequestDto({
                            cpf: "",
                            registro: "",
                            nome: "",
                            dataNascimento: "",
                            idUnidadeRetirada: 0,
                            documentos: [],
                            replicarBioCnh: false,
                            dadosProcesso: {},
                        });
                        goNext();
                    }
                    return [3 /*break*/, 5];
                case 3:
                    e_1 = _h.sent();
                    if (isAxiosError(e_1)) {
                        setError(((_c = (_b = e_1 === null || e_1 === void 0 ? void 0 : e_1.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) || "Erro desconhecido");
                        toast.error(((_e = (_d = e_1 === null || e_1 === void 0 ? void 0 : e_1.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.message) || "Erro desconhecido");
                    }
                    else {
                        setError(((_f = e_1 === null || e_1 === void 0 ? void 0 : e_1.data) === null || _f === void 0 ? void 0 : _f.message) || (e_1 === null || e_1 === void 0 ? void 0 : e_1.message) || "Erro desconhecido");
                        toast.error(((_g = e_1 === null || e_1 === void 0 ? void 0 : e_1.data) === null || _g === void 0 ? void 0 : _g.message) || (e_1 === null || e_1 === void 0 ? void 0 : e_1.message) || "Erro desconhecido");
                    }
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    function onError(values) {
        console.log("error", values);
    }
    var goExternalService = function (event) {
        var baseUrl = process.env.PORTAL_URL || "https://dev.pidigital.pi.gov.br";
        var url = baseUrl + "/app/app-detran-habilitacao/renovar-a-minha-cnh";
        var newWindow = window.open(url, "_blank");
        newWindow === null || newWindow === void 0 ? void 0 : newWindow.focus();
        event === null || event === void 0 ? void 0 : event.preventDefault();
        return false;
    };
    var isLoadingApp = isLoading;
    return (_jsxs(Container, { children: [_jsx(PageTitle, { title: "Renova\u00E7\u00E3o de CNH" }), _jsx(ServiceInfo, { children: _jsx(ServiceInfoItem, { title: "Instru\u00E7\u00F5es para solicitar a Renova\u00E7\u00E3o de CNH:", content: [
                        "Preencha corretamente os dados abaixo. Após avançar, adicione os documentos solicitados na página. Em seguida, visualize o boleto do serviço e faça o pagamento. Você pode acompanhar os detalhes da sua solicitação pelo Gov.pi Cidadão.",
                    ], listType: "ordered" }) }), _jsx(ServiceInfo, __assign({ bgColorClass: "bg-light-yellow-alert" }, { children: _jsx(ServiceInfoItem, { title: "Aten\u00E7\u00E3o!", titleIcon: _jsx(AlertTriangle, { className: "h-4 w-4" }), content: [
                        "Confira seus dados e altere se for necessário. Os documentos que deverão ser apresentados no momento da coleta biométrica deverão comprovar os dados preenchidos neste cadastro;",
                        "Para alteração do nome, nome da mãe e ou data de nascimento, o documento oficial com foto deverá ter data de emissão posterior a emissão da última CNH;",
                        'Qualquer alteração de dados como RG ou nome implicará na emissão de taxa de "renovação com alteração de dados";',
                        "A apresentação de documento oficial com foto na biometria não exige alteração de dados, para haver alteração de algum dado é necessário o preenchimento do dado no SITE;",
                    ], listType: "unordered" }) })), _jsx(Form, __assign({}, form, { children: _jsxs("form", __assign({ onSubmit: form.handleSubmit(onSubmit, onError), className: "w-full max-w-[856px] space-y-6 animate-fade-left" }, { children: [_jsxs("div", __assign({ className: "px-0 flex flex-wrap" }, { children: [_jsx(FormField, { control: form.control, name: "email", render: function (_a) {
                                        var field = _a.field;
                                        return (_jsxs(FormItem, __assign({ className: "w-full pr-0 md:pr-1 md:w-1/2 relative" }, { children: [_jsx(FormLabel, { children: "E-mail" }), _jsx(FormControl, { children: _jsx(Input, __assign({ type: "email" }, field)) }), _jsx(FormDescription, { children: "Adicione o seu e-mail principal." }), _jsx(FormMessage, {})] })));
                                    } }), _jsx(FormField, { control: form.control, name: "telefoneCelular", render: function (_a) {
                                        var field = _a.field;
                                        return (_jsxs(FormItem, __assign({ className: "w-full pl-0 md:pl-1 md:w-1/2 relative" }, { children: [_jsx(FormLabel, { children: "Contato" }), _jsx(FormControl, { children: _jsx(InputMask, __assign({ placeholder: "(99) 9 9999-9999", mask: "(99) 9 9999-9999" }, field, { onChange: function (e) {
                                                            form.setValue("telefoneCelular", e.target.value.replace(/[^\d]/g, ""));
                                                        } })) }), _jsx(FormDescription, { children: "Informe o n\u00FAmero de telefone." }), _jsx(FormMessage, {})] })));
                                    } })] })), _jsx("div", __assign({ className: "border rounded-md p-4 space-y-4" }, { children: _jsx(FormField, { control: form.control, name: "exerceAtividade", render: function (_a) {
                                    var field = _a.field;
                                    return (_jsxs(FormItem, { children: [_jsx(FormLabel, { children: "Exerce atividade remunerada?" }), _jsx(FormControl, { children: _jsxs(RadioGroup, __assign({ onValueChange: function (e) { return field.onChange(e === "sim"); }, defaultValue: "nao" }, { children: [_jsxs("div", __assign({ className: "flex items-center space-x-2" }, { children: [_jsx(RadioGroupItem, { value: "sim", id: "atividade-remunerada-sim" }), _jsx(Label, __assign({ htmlFor: "atividade-remunerada-sim", className: "font-normal" }, { children: "Sim, trabalho como motorista ou mototaxista." }))] })), _jsxs("div", __assign({ className: "flex items-center space-x-2" }, { children: [_jsx(RadioGroupItem, { value: "nao", id: "atividade-remunerada-nao" }), _jsx(Label, __assign({ htmlFor: "atividade-remunerada-nao", className: "font-normal" }, { children: "N\u00E3o trabalho como motorista ou mototaxista" }))] }))] })) }), _jsx(FormMessage, {})] }));
                                } }) })), _jsxs("div", __assign({ className: "border rounded-md p-4 space-y-4" }, { children: [_jsx(FormField, { control: form.control, name: "temCursosEspeciais", render: function (_a) {
                                        var field = _a.field;
                                        return (_jsxs(FormItem, { children: [_jsx(FormLabel, { children: "O condutor se enquadra em um dos cursos?" }), _jsx(FormControl, { children: _jsxs(RadioGroup, __assign({ onValueChange: function (e) {
                                                            if (e === "nao") {
                                                                form.resetField("cursosEspeciais");
                                                                field.onChange(false);
                                                            }
                                                            else {
                                                                field.onChange(true);
                                                            }
                                                        }, defaultValue: "nao" }, { children: [_jsxs("div", __assign({ className: "flex items-center space-x-2" }, { children: [_jsx(RadioGroupItem, { value: "sim", id: "tem-cursos-especiais-sim" }), _jsx(Label, __assign({ htmlFor: "tem-cursos-especiais-sim", className: "font-normal" }, { children: "Sim (marque os cursos)." }))] })), _jsxs("div", __assign({ className: "flex items-center space-x-2" }, { children: [_jsx(RadioGroupItem, { value: "nao", id: "tem-cursos-especiais-nao" }), _jsx(Label, __assign({ htmlFor: "tem-cursos-especiais-nao", className: "font-normal" }, { children: "N\u00E3o" }))] }))] })) }), _jsx(FormMessage, {})] }));
                                    } }), form.watch("temCursosEspeciais") &&
                                    form.watch("cursosEspeciais") && (_jsx("div", __assign({ className: "border rounded-md p-4" }, { children: _jsx(FormField, { control: form.control, name: "cursosEspeciais", render: function () { return (_jsxs(FormItem, { children: [_jsxs("div", __assign({ className: "mb-4" }, { children: [_jsx(FormLabel, __assign({ className: "text-base" }, { children: "Cursos Especiais" })), _jsx(FormDescription, { children: "Selecione os cursos que voc\u00EA possui." })] })), cursosEspeciaisList.map(function (curso) { return (_jsx(FormField, { control: form.control, name: "cursosEspeciais", render: function (_a) {
                                                        var _b;
                                                        var field = _a.field;
                                                        return (_jsxs(FormItem, __assign({ className: "flex flex-row items-start space-x-3 space-y-0" }, { children: [_jsx(FormControl, { children: _jsx(Checkbox, { checked: (_b = field.value) === null || _b === void 0 ? void 0 : _b.includes(curso.id), onCheckedChange: function (checked) {
                                                                            field.onChange(checked
                                                                                ? __spreadArray(__spreadArray([], field.value, true), [curso.id], false) : field.value.filter(function (value) { return value !== curso.id; }));
                                                                        } }) }), _jsx(FormLabel, __assign({ className: "text-sm font-normal" }, { children: curso.label }))] })));
                                                    } }, curso.id)); }), _jsx(FormMessage, {})] })); } }) })))] })), _jsxs("div", __assign({ className: "container px-0 flex flex-wrap space-y-2 md:space-y-0" }, { children: [_jsx("div", __assign({ className: "w-full pr-0 md:pr-6 md:w-1/2 relative" }, { children: _jsxs(Button, __assign({ onClick: goExternalService, className: "self-end w-full bg-etipi-green" }, { children: [_jsx("div", __assign({ className: "rotate-45" }, { children: _jsx(Share2Icon, {}) })), "Acessar servi\u00E7o no Gov.pi Cidad\u00E3o"] })) })), _jsx("div", __assign({ className: cn("w-full pl-0 md:pl-6 md:w-1/2 relative", isLoadingApp && "cursor-progress") }, { children: _jsx(Button, __assign({ type: "submit", className: "self-end w-full bg-etipi-blue", disabled: isLoadingApp }, { children: isLoadingApp ? _jsx(LoadingSpinner, {}) : "Avançar" })) }))] }))] })) }))] }));
}
